const state = {
    sidebarOpen: false,
  };
  
  const mutations = {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebar(state, isOpen) {
      state.sidebarOpen = isOpen;
    },
  };
  
  const actions = {
    toggleSidebar({ commit }) {
      commit("toggleSidebar");
    },
    setSidebar({ commit }, isOpen) {
      commit("setSidebar", isOpen);
    },
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
  };
  